import { VStack } from '@chakra-ui/react';
import { CONTAINER_PADDINGS } from '../../Layouts/Container';
import { OrganizationPipelineCardTabs } from './OrganizationPipelineCardTabs';
import { OrganizationPipelineContextProvider } from './OrganizationPipelineContext';
import { OrganizationPipelineHeader } from './OrganizationPipelineHeader';
import { OrganizationPipelineTable } from './OrganizationPipelineTable';

export const OrganizationPipeline = () => {
  return (
    <OrganizationPipelineContextProvider>
      <VStack
        height="100dvh"
        width={{ base: '100%', md: '80%' }}
        {...CONTAINER_PADDINGS}
      >
        <OrganizationPipelineHeader />
        <OrganizationPipelineCardTabs />
        <OrganizationPipelineTable />
      </VStack>
    </OrganizationPipelineContextProvider>
  );
};
